import { render, staticRenderFns } from "./NovoPremio.vue?vue&type=template&id=65e14e56"
import script from "./NovoPremio.vue?vue&type=script&lang=ts"
export * from "./NovoPremio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports